import {
  generateSlugs,
  modify_category_tree,
  modifyCategoryTreeDataHandler,
} from '@/utils/category';
import { createIndexedDbStorage } from '@/utils/storage/indexeddb-storage';
import { findObjectByIdV2 } from '@/utils/global';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialValues = {
  categoryTreeData: null,
  menuTreeData: null,
  footerCT: null,
  _hasHydrated: false,
  slugs: {},
};

const useCategoryStore = create(
  persist(
    (set) => ({
      ...initialValues,
      setHasHydrated: (state) => {
        set({
          _hasHydrated: state,
        });
      },
      setCategoryTree: (data) => {
        const optimizedData = {
          id: data.id,
          children_data: modify_category_tree(data.children_data),
          cacheTime: data.cacheTime,
          locale: data.locale,
        };

        set({
          categoryTreeData: optimizedData,
          footerCT: modifyCategoryTreeDataHandler(
            'footer',
            data?.children_data
          ),
          menuTreeData: modifyCategoryTreeDataHandler(
            'menu',
            data?.children_data
          ),
          slugs: generateSlugs(data?.children_data, ''),
        });
      },
      getCurrentCategory: (key, value) => {
        const state = useCategoryStore.getState();
        const findCategory = findObjectByIdV2(
          state.categoryTreeData?.children_data || [],
          key,
          value
        );
        return findCategory || null;
      },
    }),
    {
      name: 'category-store',
      onRehydrateStorage: (state) => {
        return () => state.setHasHydrated(true);
      },
      storage: createIndexedDbStorage('category-store'),
    }
  )
);

export default useCategoryStore;
